module.exports = __webpack_public_path__ + "img/volkova.60edca74.jpg";